import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=adcdf04e&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=adcdf04e&prod&lang=css"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=adcdf04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcdf04e",
  null
  
)

export default component.exports